module.exports = __webpack_public_path__ + "791a6a2440a00259f21c9c0264223123.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/photo_selector/photo_selector_coke.png
// module id = 563
// module chunks = 0